module.exports = __webpack_public_path__ + "assets/yotpo-reviews.7f3fab68.svg";